import { __assign } from "tslib";
var defaultExtrator = function (baseUrl) { return function (s) { return "" + baseUrl + s.slug; }; };
export var addUrl = function (baseUrl, array, mapToUrl) {
    if (mapToUrl === void 0) { mapToUrl = defaultExtrator(baseUrl); }
    return array && array.map(function (_) { return (__assign(__assign({}, _), { to: mapToUrl(_) })); });
};
//# sourceMappingURL=addUrl.js.map